import { useFedStore, useL } from '../store';
import { useFedContent, uploadUrl, isPublished } from '../content';
import { useAppStore } from '../../store';
import { Ic } from '../icons';
import { Rv, CountUp } from '../ui';
import { cover, coverTour, tl, hasEntryFee, teamRegistrationOpen, registrationPending, registrationOpensLabel, sortTournaments } from '../data';
import useTournamentClock from '../useTournamentClock';
import DotaPoster from '../components/DotaPoster';
import seriesArt from '../assets/home-2026/tournament-series.png';

import heroes from '../assets/home-2026/heroes.webp';
import featuredArt from '../assets/home-2026/featured.webp';
import tournamentsArt from '../assets/home-2026/tournaments.webp';
import ballArt from '../assets/home-2026/ball.webp';
import leagueArt from '../assets/home-2026/league.webp';
import academyArt from '../assets/home-2026/academy.webp';
import tiktokIcon from '../assets/home-2026/tiktok.webp';
import twitchIcon from '../assets/home-2026/twitch.webp';
import instagramIcon from '../assets/home-2026/instagram.webp';

const COPY = {
  ru: {
    heroLine1: 'Киберспорт', heroLine2: 'региона СКО',
    heroText: 'Турниры по CS2, EA SPORTS FC и другим дисциплинам для школьников, студентов и любителей. Регистрируйся, следи за сеткой в реальном времени и смотри прямые трансляции.',
    join: 'Стать участником', all: 'Все турниры',
    now: 'Ближайшие турниры', nowText: 'Текущие и ближайшие турниры федерации', allEvents: 'Смотреть все',
    prizeEyebrow: 'Выплачено участникам турниров', prizeLabel: 'Общий призовой фонд', prizeNote: 'Реальные выплаты победителям соревнований федерации',
    latestNews: 'Последние новости', latestNewsText: 'Турниры, результаты и жизнь киберспорта региона', allNews: 'Все новости', read: 'Читать',
    live: 'Идёт сейчас', soon: 'Скоро', open: 'Зарегистрироваться', registration: 'Регистрация открыта', noEvents: 'Новые турниры скоро появятся',
    stats: ['Участников за сезон', 'Команд в базе', 'Турниров прошло', 'Прямых трансляций'],
    directions: 'Направления федерации', directionText: 'От школьных лиг до открытых кубков — единая площадка для всех, кто хочет играть, судить или организовывать турниры в регионе.',
    directionNames: ['Турниры и кубки', 'Лига', 'Академия'],
    socials: 'Мы в социальных сетях', partners: 'Партнёры и спонсоры', organizer: 'Организатор', itCompany: 'IT-компания',
    ready1: 'Готов выйти', ready2: 'на сцену?', readyText: 'Создай аккаунт, собери команду и участвуй в ближайших турнирах федерации.',
    create: 'Создать аккаунт', contact: 'Связаться с нами', openSocial: 'Открыть профиль',
  },
  kz: {
    heroLine1: 'СҚО аймағының', heroLine2: 'киберспорты',
    heroText: 'Оқушыларға, студенттерге және әуесқойларға арналған CS2, EA SPORTS FC және басқа пәндер бойынша турнирлер. Тіркеліп, турнир кестесін бақылап, тікелей эфирлерді көр.',
    join: 'Қатысушы болу', all: 'Барлық турнирлер',
    now: 'Алдағы турнирлер', nowText: 'Федерацияның ағымдағы және алдағы турнирлері', allEvents: 'Барлығын көру',
    prizeEyebrow: 'Турнир қатысушыларына төленді', prizeLabel: 'Жалпы жүлде қоры', prizeNote: 'Федерация жарыстарының жеңімпаздарына нақты төлемдер',
    latestNews: 'Соңғы жаңалықтар', latestNewsText: 'Турнирлер, нәтижелер және аймақ киберспортының өмірі', allNews: 'Барлық жаңалықтар', read: 'Оқу',
    live: 'Қазір өтуде', soon: 'Жақында', open: 'Тіркелу', registration: 'Тіркелу ашық', noEvents: 'Жаңа турнирлер жақында шығады',
    stats: ['Маусым қатысушылары', 'Базадағы командалар', 'Өткен турнирлер', 'Тікелей эфир сағаты'],
    directions: 'Федерация бағыттары', directionText: 'Мектеп лигаларынан ашық кубоктарға дейін — ойнағысы, төрелік еткісі немесе аймақта турнир ұйымдастырғысы келетіндердің бәріне ортақ алаң.',
    directionNames: ['Турнирлер мен кубоктар', 'Лига', 'Академия'],
    socials: 'Біз әлеуметтік желілердеміз', partners: 'Серіктестер мен демеушілер', organizer: 'Ұйымдастырушы', itCompany: 'IT-компания',
    ready1: 'Сахнаға шығуға', ready2: 'дайынсың ба?', readyText: 'Аккаунт аш, команда жина және федерацияның жақын турнирлеріне қатыс.',
    create: 'Аккаунт ашу', contact: 'Бізбен байланысу', openSocial: 'Профильді ашу',
  },
};

const SOCIALS = [
  { name: 'fcs_sqo', network: 'TikTok', href: 'https://www.tiktok.com/@fcs_sqo', icon: tiktokIcon },
  { name: 'cybersqo', network: 'Twitch', href: 'https://www.twitch.tv/cybersqo', icon: twitchIcon },
  { name: 'fcs_sqo', network: 'Instagram', href: 'https://www.instagram.com/fcs_sqo/', icon: instagramIcon },
];

function Stage({ className = '', children, heroesPosition = '', step }) {
  return (
    <section className={`home26-stage ${className}`} data-step={step}>
      <div className="home26-stage-wash" />
      <img className={`home26-heroes ${heroesPosition}`} src={heroes} alt="" aria-hidden="true" />
      {step && <span className="home26-stage-marker" aria-hidden="true"><i />{String(step).padStart(2, '0')}</span>}
      <div className="home26-stage-content">{children}</div>
      {step && <div className="home26-stage-transition" aria-hidden="true" />}
    </section>
  );
}

function MainButtons({ goJoin, go, copy, activeTour }) {
  return (
    <div className="home26-actions">
      <button className="home26-btn primary" onClick={goJoin}><Ic name="zap" size={20} />{activeTour?.form?.open ? copy.open : copy.join}</button>
      <button className="home26-btn secondary" onClick={() => go('tournaments')}>{copy.all}</button>
    </div>
  );
}

export default function FedHome() {
  const { go, lang, openSponsor, openApply, setAuthReturn } = useFedStore();
  const user = useAppStore((state) => state.user);
  const L = useL();
  const C = COPY[lang === 'kz' ? 'kz' : 'ru'];
  const tournaments = useFedContent((state) => state.tournaments);
  useTournamentClock(tournaments);
  const news = useFedContent((state) => state.news);
  const counters = useFedContent((state) => state.counters);
  const partners = useFedContent((state) => state.partners);
  const orderedTours = sortTournaments(tournaments);
  const activeTour = orderedTours.find((tour) => tour.status !== 'done' && (teamRegistrationOpen(tour) || registrationPending(tour)))
    || orderedTours.find((tour) => tour.status !== 'done' && tour.form?.open && tour.form?.fields?.length)
    || orderedTours.find((tour) => tour.status === 'live')
    || orderedTours.find((tour) => tour.status === 'soon');
  const goJoin = () => {
    if (!activeTour) return go('tournaments');
    if (activeTour.hasData === 'team') {
      go('tournament', { tourId: activeTour.id, tourTab: teamRegistrationOpen(activeTour) ? 'reg' : 'overview' });
      return;
    }
    if (activeTour.form?.open && activeTour.form?.fields?.length) {
      if (!user) {
        setAuthReturn({ route: 'tournament', extra: { tourId: activeTour.id, tourTab: 'overview' } });
        go('auth', { authMode: 'signup' });
      } else {
        go('tournament', { tourId: activeTour.id, tourTab: 'overview' });
        openApply(activeTour.id);
      }
      return;
    }
    go('tournament', { tourId: activeTour.id, tourTab: 'overview' });
  };
  const statFallback = [{ value: 500, suffix: '+' }, { value: 72, suffix: '' }, { value: 4, suffix: '' }, { value: 50, suffix: 'ч' }];
  const stats = statFallback.map((fallback, index) => ({ ...fallback, ...(counters[index] || {}), label: C.stats[index] }));
  const currentTournaments = orderedTours
    .filter((tour) => tour.status === 'live' || tour.status === 'soon')
    .slice(0, 1);
  const parseNewsDate = (value = '') => {
    const [day, month, year] = String(value).split('.').map(Number);
    return year && month && day ? new Date(year, month - 1, day).getTime() : 0;
  };
  const latestNews = news.filter(isPublished).sort((a, b) => parseNewsDate(b.date) - parseNewsDate(a.date)).slice(0, 3);

  return (
    <main className="home26">
      <Stage className="home26-hero" heroesPosition="hero-pos">
        <Rv className="home26-hero-copy">
          <span className="home26-kicker">NORTH KZ · CYBERSPORT FEDERATION</span>
          <h1><span>{C.heroLine1}</span><strong>{C.heroLine2}</strong></h1>
          <p>{C.heroText}</p>
          <MainButtons goJoin={goJoin} go={go} copy={C} activeTour={activeTour} />
        </Rv>
      </Stage>

      <Stage className="home26-now" step={1}>
        <Rv className="home26-block-head">
          <div><span>{C.nowText}</span><h2>{C.now}</h2></div>
          <button onClick={() => go('tournaments')}>{C.allEvents}<Ic name="chevR" size={18} /></button>
        </Rv>
        <Rv className="home26-prize" delay={0.05}>
          <div><span>{C.prizeEyebrow}</span><strong><CountUp className="home26-prize-value" target={1000000} /><i>₸</i></strong></div>
          <div><b>{C.prizeLabel}</b><p>{C.prizeNote}</p></div>
        </Rv>
        <div className="home26-tour-grid">
          <Rv as="article" className="home26-tour-card home26-tour-promo" delay={0.1} onClick={() => go('tournaments')}>
            <div className="home26-tour-art" style={{ height: 'clamp(220px,30svh,300px)', aspectRatio: 'auto' }}>
              <img src={seriesArt} alt={lang === 'kz' ? 'Федерация турнирлері' : 'Турниры федерации'} style={{ objectFit: 'contain', background: '#250809' }} />
              <span>{lang === 'kz' ? 'Барлық пәндер' : 'Все дисциплины'}</span>
              <em className="soon">{C.soon}</em>
            </div>
            <div className="home26-tour-info">
              <small>CS2 · EA SPORTS FC · MLBB · DOTA 2</small>
              <h3>{lang === 'kz' ? 'Федерация турнирлерінің сериясы' : 'Серия турниров федерации'}</h3>
              <p><Ic name="calendar" size={15} />{lang === 'kz' ? 'Жаңа турнирлер жақында' : 'Новые турниры уже скоро'}</p>
              <button>{C.all}<Ic name="chevR" size={16} /></button>
            </div>
          </Rv>
          {currentTournaments.map((tour, index) => (
            <Rv as="article" className="home26-tour-card" delay={0.17 + index * 0.07} key={tour.id} onClick={() => go('tournament', { tourId: tour.id, tourTab: 'overview' })}>
              <div className={`home26-tour-art${tour.teamGame === 'dota2' && tour.image ? ' dota-tour-card-art' : ''}`} style={{ background: coverTour(tour.hue), height: 'clamp(220px,30svh,300px)', aspectRatio: 'auto' }}>
                {tour.teamGame === 'dota2' && !tour.image && <DotaPoster tour={tour} lang={lang} compact />}
                {(tour.image || tour.id === 'tdq0g2qy') && <img src={tour.id === 'tdq0g2qy' ? '/assets/5298879394677990360.jpg' : tour.image} alt={tl(tour, 'title', lang)} style={tour.id === 'tdq0g2qy' ? { objectFit: 'contain', background: '#0871b6' } : undefined} />}
                <span>{tour.disc}</span>
                <em className={tour.status}>{teamRegistrationOpen(tour) ? C.registration : tour.status === 'live' ? C.live : C.soon}</em>
              </div>
              <div className="home26-tour-info">
                <small>{tour.game || tour.platform}</small>
                <h3>{tl(tour, 'title', lang)}</h3>
                <p><Ic name="calendar" size={15} />{tl(tour, 'date', lang) || C.soon}</p>
                {tour.teamGame === 'dota2' && <p><Ic name="trophy" size={15} />{tl(tour, 'prize', lang)}{hasEntryFee(tour) && tl(tour, 'fee', lang) && ` · ${tl(tour, 'fee', lang)}`}</p>}
                {registrationPending(tour) && <p>{registrationOpensLabel(tour, lang)}</p>}
                <button onClick={(event) => { event.stopPropagation(); tour.id === activeTour?.id ? goJoin() : go('tournament', { tourId: tour.id, tourTab: teamRegistrationOpen(tour) ? 'reg' : 'overview' }); }}>
                  {teamRegistrationOpen(tour) ? C.open : (lang === 'kz' ? 'Турнир туралы' : 'Подробнее')}<Ic name="chevR" size={16} />
                </button>
              </div>
            </Rv>
          ))}
          {!currentTournaments.length && <p className="home26-empty">{C.noEvents}</p>}
        </div>
      </Stage>

      <Stage className="home26-results" heroesPosition="results-pos" step={2}>
        <div className="home26-stat-grid">
          {stats.map((stat, index) => (
            <Rv className="home26-stat" delay={index * 0.06} key={stat.label}>
              <div><CountUp target={Number(stat.value) || 0} /><small>{stat.suffix}</small></div>
              <span>{stat.label}</span>
            </Rv>
          ))}
        </div>
        <Rv className="home26-featured" delay={0.12} onClick={() => go('tournament', { tourId: 'fifa-open-2026', tourTab: 'overview' })}>
          <img src={featuredArt} alt="FIFA OPEN SКО — главное событие сезона" />
          <span className="home26-featured-cta">{L.featCta} <Ic name="chevR" size={17} /></span>
        </Rv>
      </Stage>

      <Stage className="home26-directions" heroesPosition="directions-pos" step={3}>
        <Rv className="home26-section-head">
          <h2>{C.directions}</h2>
          <p>{C.directionText}</p>
        </Rv>
        <div className="home26-direction-grid">
          {[
            { image: tournamentsArt, extra: ballArt, className: 'tournaments' },
            { image: leagueArt, className: 'league' },
            { image: academyArt, className: 'academy' },
          ].map((item, index) => (
            <Rv className={`home26-direction-card ${item.className}`} delay={index * 0.07} key={item.className}>
              <h3>{C.directionNames[index]}</h3>
              {item.extra && <img className="home26-ball" src={item.extra} alt="" />}
              <img className="home26-direction-person" src={item.image} alt="" />
            </Rv>
          ))}
        </div>
      </Stage>

      <Stage className="home26-news" step={4}>
        <Rv className="home26-block-head">
          <div><span>{C.latestNewsText}</span><h2>{C.latestNews}</h2></div>
          <button onClick={() => go('news')}>{C.allNews}<Ic name="chevR" size={18} /></button>
        </Rv>
        <div className="home26-news-grid">
          {latestNews.map((item, index) => (
            <Rv as="article" className="home26-news-card" delay={index * 0.07} key={item.id} onClick={() => go('article', { articleId: item.id })}>
              <div className="home26-news-art" style={{ background: cover(item.hue) }}>
                {item.cover && <img src={uploadUrl(item.cover)} alt="" />}
                <span>{item[`cat_${lang}`] || item.cat_ru}</span>
              </div>
              <div className="home26-news-copy">
                <time>{item.date}</time>
                <h3>{item[`title_${lang}`] || item.title_ru}</h3>
                <p>{item[`ex_${lang}`] || item.ex_ru}</p>
                <b>
                  {C.read}
                  <svg className="home26-news-arrow" viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M2.6 5.25 21.4 3.7l-9.08 7.72L2.6 5.25Z" />
                    <path d="m12.92 12.12 8.48-8.42-5.62 17.15-2.86-8.73Z" />
                  </svg>
                </b>
              </div>
            </Rv>
          ))}
        </div>
      </Stage>

      <Stage className="home26-socials" heroesPosition="social-pos" step={5}>
        <Rv as="h2">{C.socials}</Rv>
        <div className="home26-social-list">
          {SOCIALS.map((social, index) => (
            <Rv as="a" className="home26-social-link" delay={index * 0.06} href={social.href} target="_blank" rel="noreferrer" key={social.network} aria-label={`${C.openSocial}: ${social.network}`}>
              <span><small>{social.network}</small><b>{social.name}</b></span>
              <img src={social.icon} alt="" />
              <Ic name="external" size={22} />
            </Rv>
          ))}
        </div>
      </Stage>

      <Stage className="home26-partners" heroesPosition="partners-pos" step={6}>
        <Rv as="h2">{C.partners}</Rv>
        <div className="home26-partner-shell">
          <div className="home26-partner-grid">
            {partners.map((partner, index) => {
              const role = partner[`role_${lang}`] || partner.role_ru || partner.role_kz || '';
              const linked = Boolean(partner.link);
              return (
                <Rv
                  as={linked ? 'a' : 'article'}
                  className={`home26-partner-card${linked ? ' is-link' : ''}`}
                  delay={Math.min(index * 0.07, 0.28)}
                  key={partner.id || partner.name || index}
                  href={linked ? partner.link : undefined}
                  target={linked ? '_blank' : undefined}
                  rel={linked ? 'noreferrer' : undefined}
                >
                  <div
                    className="home26-partner-logo"
                    style={!partner.logo && partner.badge ? { background: partner.badge } : undefined}
                  >
                    {partner.logo
                      ? <img src={uploadUrl(partner.logo)} alt={partner.name || ''} />
                      : <b>{partner.mono || String(partner.name || '?').slice(0, 2).toUpperCase()}</b>}
                  </div>
                  <h3>{partner.name || 'Партнёр'}</h3>
                  {role && <span>{role}</span>}
                  {linked && <Ic name="external" size={16} />}
                </Rv>
              );
            })}
          </div>
          <button className="home26-partner-more" onClick={openSponsor}><Ic name="plus" size={24} />{L.partnersJoinBtn}</button>
        </div>
      </Stage>

      <Stage className="home26-cta" heroesPosition="cta-pos" step={7}>
        <Rv className="home26-cta-copy">
          <h2><span>{C.ready1}</span><strong>{C.ready2}</strong></h2>
          <p>{C.readyText}</p>
          <div className="home26-actions">
            <button className="home26-btn primary" onClick={() => go('auth', { authMode: 'signup' })}>{C.create}</button>
            <button className="home26-btn secondary" onClick={() => go('contacts')}>{C.contact}</button>
          </div>
        </Rv>
      </Stage>
    </main>
  );
}
